import React from "react";
import {
  roundCurrencyVND,
  formatCurrencyVND,
} from "../utils/CurrencyFormat.js";
import { Link } from "react-router-dom";

const ProductItem = ({ data }) => {
  const { name, image, price, salePrice, slug } = data || {};
  const discount = Math.round(((price - salePrice) / price) * 100);

  return (
    <>
      <Link to={`/product/` + slug} className="product-item">
        <div className="hot-product-content-item">
          {discount && salePrice > 0 && (
            <div className="hot-product-badge">-{discount}%</div>
          )}
          <div className="hot-product-img-item">
            <img src={image} alt="" />
          </div>
          <p>{name}</p>
          {salePrice > 0 ? (
            <div className="hot-product-price">
              <span>{formatCurrencyVND(price)}</span>
              <span>{formatCurrencyVND(salePrice)}</span>
            </div>
          ) : (
            <div className="hot-product-price-non-discount">
              <span>{formatCurrencyVND(price)}</span>
            </div>
          )}
        </div>
      </Link>
    </>
  );
};

export default ProductItem;
